<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2020-03-04 16:15:58
 * @LastEditTime: 2020-03-04 16:19:38
 -->
<template>
  <div class="lang">
    <span
      :class="{checked: curLang === 'zh'}"
      @click="changeLang('zh')"
    >
      中文
    </span>
    /
    <span
      :class="{checked: curLang === 'en'}"
      @click="changeLang('en')"
    >
      EN
    </span>
  </div>
  <!--<bsUpmenu-->
    <!--v-model="curLang"-->
    <!--class="lang"-->
    <!--:list="list"-->
    <!--:is-left="true"-->
    <!--:icon-name="'#arr-down'"-->
    <!--menu-width="124"-->
    <!--pleft="8px"-->
    <!--align="3px"-->
    <!--@click-item="changeLang"-->
  <!--&gt;-->
    <!--<template-->
      <!--slot="name"-->
      <!--slot-scope="d"-->
    <!--&gt;-->
      <!--<span class="u-li">-->
        <!--<svg-->
          <!--v-if="d.data.data.key == curLang"-->
          <!--class="gou"-->
        <!--&gt;-->
          <!--<use xlink:href="#gou" />-->
        <!--</svg>-->
        <!--{{ $t(d.data.data.name) }}</span>-->
    <!--</template>-->
  <!--</bsUpmenu>-->
</template>
<script>
import bsUpmenu from 'components/business/upmenu/index.vue'
import { getLanguage, setLanguage } from 'js/util/util'

export default {
  components: {
    bsUpmenu,
  },
  data() {
    return {
      // 语言列表
      list: [{
        name: '简体中文',
        key: 'zh',
      },
      {
        name: 'English',
        key: 'en',
      }],
      curLang: 'zh', // 当前默认语言
    }
  },
  created() {
    this.curLang = (this.$route.query && this.$route.query.language) || getLanguage()
  },
  methods: {
    // 切换语言
    changeLang(lang) {
      // 重新设置语言
      this.curLang = lang
      setLanguage(lang)
      window.location.reload()
    },
  },
}
</script>
<style lang="less" scoped>
.lang{
  cursor: pointer;
  box-sizing: border-box;
  .checked{
    color: #0A64FA;
  }
}
.gou{
  width: 12px;
  height: 9px;
  position: absolute;
  top: 7px;
  left: -20px;
}
.u-li{
  position: relative;
  margin-left: 2px;
}
</style>
